// import React, { useState, useEffect } from "react";
// import { BrowserRouter as Router } from "react-router-dom";
// import Navbar from "./components/Navbar";
// import HeroSection from "./components/HeroSection";
// import ServicesSection from "./components/ServicesSection";
// import ProjectsSection from "./components/ProjectsSection";
// // import AboutSection from "./components/sections/AboutSection";
// // import ContactSection from "./components/sections/ContactSection";
// import Footer from "./components/Footer";
// import { Terminal } from "lucide-react";

// function App() {
//   const [isLoading, setIsLoading] = useState(true);

//   useEffect(() => {
//     // Simulate loading screen
//     const timer = setTimeout(() => {
//       setIsLoading(false);
//     }, 2000);
//     return () => clearTimeout(timer);
//   }, []);

//   // Loading screen
//   if (isLoading) {
//     return (
//       <div className="fixed inset-0 flex items-center justify-center bg-black">
//         <div className="text-center">
//           <div className="flex items-center mb-4 justify-center">
//             <Terminal className="w-8 h-8 text-blue-600 mr-2" />
//             <div className="text-4xl font-mono text-white">
//               TK<span className="text-blue-600 animate-blink">_</span>
//             </div>
//           </div>
//           <div className="w-16 h-16 border-t-4 border-blue-500 border-solid rounded-full animate-spin mx-auto"></div>
//           <div className="mt-4 text-gray-400 font-mono text-sm">
//             Initializing services...
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <Router>
//       <div className="bg-black text-black">
//         <Navbar />
//         <main>
//           <HeroSection />
//           <div className="flex flex-col items-center">
//             <div className="w-[97%] mx-auto">
//               <ServicesSection />
//             </div>
//             <div className="w-[97%] mx-auto">
//               <ProjectsSection />
//             </div>
//             {/* Other sections will be added here */}
//           </div>
//         </main>
//         <Footer />
//       </div>

//       {/* Custom animations */}
//       <style jsx global>{`
//         @keyframes blink {
//           0%,
//           100% {
//             opacity: 1;
//           }
//           50% {
//             opacity: 0;
//           }
//         }

//         .animate-blink {
//           animation: blink 1s infinite;
//         }

//         @keyframes float-slow {
//           0%,
//           100% {
//             transform: translateY(0);
//           }
//           50% {
//             transform: translateY(-10px);
//           }
//         }

//         .animate-float-slow {
//           animation: float-slow 5s ease-in-out infinite;
//         }

//         @keyframes float-slower {
//           0%,
//           100% {
//             transform: translateY(0);
//           }
//           50% {
//             transform: translateY(-15px);
//           }
//         }

//         .animate-float-slower {
//           animation: float-slower 7s ease-in-out infinite;
//         }

//         @keyframes pulse-slow {
//           0%,
//           100% {
//             opacity: 0.5;
//           }
//           50% {
//             opacity: 0.3;
//           }
//         }

//         .animate-pulse-slow {
//           animation: pulse-slow 4s cubic-bezier(0.4, 0, 0.6, 1) infinite;
//         }

//         @keyframes ping-slow {
//           75%,
//           100% {
//             transform: scale(2);
//             opacity: 0;
//           }
//         }

//         .animate-ping-slow {
//           animation: ping-slow 2s cubic-bezier(0, 0, 0.2, 1) infinite;
//         }

//         @keyframes spin-slow {
//           to {
//             transform: rotate(360deg);
//           }
//         }

//         .animate-spin-slow {
//           animation: spin-slow 8s linear infinite;
//         }
//       `}</style>
//     </Router>
//   );
// }

// export default App;
import React, { useState, useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import ServicesSection from "./components/ServicesSection";
import ProjectsSection from "./components/ProjectsSection";
import AboutSection from "./components/AboutSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import { Terminal } from "lucide-react";

function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Simulate loading screen
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  // Loading screen
  if (isLoading) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-black">
        <div className="text-center">
          <div className="flex items-center mb-4 justify-center">
            <Terminal className="w-8 h-8 text-blue-600 mr-2" />
            <div className="text-4xl font-mono text-white">
              TK<span className="text-blue-600 animate-blink">_</span>
            </div>
          </div>
          <div className="w-16 h-16 border-t-4 border-blue-500 border-solid rounded-full animate-spin mx-auto"></div>
          <div className="mt-4 text-gray-400 font-mono text-sm">
            Initializing services...
          </div>
        </div>
      </div>
    );
  }

  return (
    <Router>
      <div className="bg-black text-black">
        <Navbar />
        <main>
          <HeroSection />
          <div className="flex flex-col items-center">
            <div className="w-[97%] mx-auto">
              <ServicesSection />
              <ProjectsSection />
              <AboutSection />
              <ContactSection />
              {/* We'll add more sections based on your specific instructions */}
            </div>
          </div>
        </main>
        <Footer />
      </div>

      {/* Custom animations */}
      <style jsx global>{`
        @keyframes blink {
          0%,
          100% {
            opacity: 1;
          }
          50% {
            opacity: 0;
          }
        }

        .animate-blink {
          animation: blink 1s infinite;
        }

        @keyframes float-slow {
          0%,
          100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-10px);
          }
        }

        .animate-float-slow {
          animation: float-slow 5s ease-in-out infinite;
        }

        @keyframes float-slower {
          0%,
          100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-15px);
          }
        }

        .animate-float-slower {
          animation: float-slower 7s ease-in-out infinite;
        }

        @keyframes pulse-slow {
          0%,
          100% {
            opacity: 0.5;
          }
          50% {
            opacity: 0.3;
          }
        }

        .animate-pulse-slow {
          animation: pulse-slow 4s cubic-bezier(0.4, 0, 0.6, 1) infinite;
        }

        @keyframes ping-slow {
          75%,
          100% {
            transform: scale(2);
            opacity: 0;
          }
        }

        .animate-ping-slow {
          animation: ping-slow 2s cubic-bezier(0, 0, 0.2, 1) infinite;
        }

        @keyframes spin-slow {
          to {
            transform: rotate(360deg);
          }
        }

        .animate-spin-slow {
          animation: spin-slow 8s linear infinite;
        }
      `}</style>
    </Router>
  );
}

export default App;
